export default [
    'pdf', 'txt', 'rtf', 'doc', 'docx', 'xls', 'xlsx', 'odt', 'ods', 'sxw',
    'zip', '7z', 'rar', 'dwg', 'dwt', 'dxf', 'dwf', 'dwfx', 'svg', 'sldprt', 'sldasm',
    'dgn', 'ifc', 'skp', '3ds', 'dae', 'obj', 'rfa', 'rte'
]
